import React, { useState, useEffect, useRef } from "react";
import debounce from "lodash/debounce";
import { Col } from "react-bootstrap";
import { number, bool, string } from "prop-types";

const NumberedScoreScale = ({
  cellSpan,
  hasScoreRange,
  maxScore,
  score,
  scoreRangeMax,
  scoreRangeMin,
  hideNumbers,
  cellStyle,
}) => {
  const [numberedScaleWidth, setNumberedScaleWidth] = useState(null);

  const numberedScale = useRef(null);

  useEffect(() => {
    function handleResize() {
      // Set window width/height to state
      if (numberedScale.current) {
        setNumberedScaleWidth(
          Math.round(numberedScale.current.getBoundingClientRect().width)
        );
      }
    }

    // Add event listener
    window.addEventListener("resize", debounce(handleResize, 150));

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", () => handleResize);
  }, []);

  const getCellClass = (index) => {
    if (cellStyle === "wpp") {
      switch (true) {
        case index < 5:
          return "scale-cell-orange";
        case index >= 5 && index < 10:
          return "scale-cell-green-striped";
        default:
          return "scale-cell-green";
      }
    }
    return "";
  };

  if (maxScore) {
    const numberOfCells = maxScore / cellSpan;
    const cellWidth = 100 / numberOfCells;

    return (
      <Col className="px-0" ref={numberedScale}>
        <ul className="numbered score-scale-row">
          {Array.from({ length: numberOfCells }).map((_, i) => (
            <li
              key={i} // eslint-disable-line react/no-array-index-key
              style={{ width: `${cellWidth}%` }}
              className={getCellClass(i)}
            ></li>
          ))}
        </ul>
        <ul className={`numbered-score-scale-label-row ${cellStyle || ""}`}>
          {Array.from({ length: numberOfCells }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i} style={{ width: `${cellWidth}%` }}>
              <span>{hideNumbers ? null : cellSpan * (i + 1)}</span>
            </li>
          ))}
        </ul>
        <div
          id="numbered-score-label-zero"
          className={`${hideNumbers ? "make-transparent" : ""}`}
        >
          0
        </div>
        {String(score) && numberedScaleWidth && (
          <div
            className="scale-score-bubble"
            style={{
              left: `${Math.round((score / maxScore) * numberedScaleWidth)}px`,
            }}
          >
            <strong>{score}</strong>
          </div>
        )}
        {hasScoreRange && numberedScaleWidth && (
          <div
            className="scale-score-range-highlight-green"
            style={{
              left: `${Math.round(
                (scoreRangeMin / maxScore) * numberedScaleWidth
              )}px`,
              width: `${Math.round(
                ((scoreRangeMax - scoreRangeMin) / maxScore) * 100
              )}%`,
            }}
          ></div>
        )}
      </Col>
    );
  }
};

NumberedScoreScale.propTypes = {
  cellSpan: number,
  hasScoreRange: bool,
  maxScore: number,
  score: number,
  scoreRangeMax: number,
  scoreRangeMin: number,
  hideNumbers: bool,
  cellStyle: string,
};

export default NumberedScoreScale;
